import { makeStyles, tokens } from '@fluentui/react-components';

export const useHealthGoalsSectionStyles = makeStyles({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingHorizontalXXL,
  },
});
